var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "el-dialog",
        {
          staticClass: "order_box",
          attrs: {
            visible: _vm.visible,
            title: "赔付操作",
            "close-on-click-modal": false,
            "close-on-press-escape": !_vm.loadSubmit,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.initLoading,
                  expression: "initLoading",
                },
              ],
              staticClass: "description",
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("基础信息")]),
              _vm._v(" "),
              _c("div", { staticClass: "acea-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "description-term",
                    staticStyle: { width: "33%" },
                  },
                  [_vm._v(_vm._s("售后单号：" + (_vm.detailInfo.id || "--")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "description-term",
                    staticStyle: { width: "33%" },
                  },
                  [
                    _vm._v(
                      _vm._s("订单编号：" + (_vm.detailInfo.orderCode || "--"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "description-term",
                    staticStyle: { width: "33%" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        "售后类型：" +
                          (_vm.detailInfo.aftersaleTypeDesc || "--")
                      )
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [_vm._v("赔付信息")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "compensationForm",
                  attrs: {
                    model: _vm.compensationData,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "赔付类型", prop: "compensationType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择赔付类型" },
                          model: {
                            value: _vm.compensationData.compensationType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.compensationData,
                                "compensationType",
                                $$v
                              )
                            },
                            expression: "compensationData.compensationType",
                          },
                        },
                        _vm._l(_vm.compensationTypeOption, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "赔付金额(福豆)",
                        prop: "compensationAmount",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          precision: 2,
                          step: 1,
                          min: 0.01,
                          disabled: _vm.loadSubmit,
                          placeholder: "请输入赔付福豆数量",
                        },
                        model: {
                          value: _vm.compensationData.compensationAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.compensationData,
                              "compensationAmount",
                              $$v
                            )
                          },
                          expression: "compensationData.compensationAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "赔付说明", prop: "compensationRemark" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入赔付说明",
                          resize: "none",
                        },
                        model: {
                          value: _vm.compensationData.compensationRemark,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.compensationData,
                              "compensationRemark",
                              $$v
                            )
                          },
                          expression: "compensationData.compensationRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  class: { "is-disabled": _vm.buttonClicked || _vm.loadSubmit },
                  attrs: {
                    type: "primary",
                    loading: _vm.loadSubmit,
                    disabled: _vm.buttonClicked || _vm.loadSubmit,
                  },
                  on: { click: _vm.onCompensationSubmit },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.loadSubmit ? "处理中..." : "确认赔付") +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.loadSubmit },
                  on: { click: _vm.handleClose },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }